var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-footer"},[_c('thai-qr-pay-label'),_c('share-footer-button',{staticClass:"container",on:{"click":_vm.confirm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }